import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { getUserMailboxInfo } from 'owa-client-ids';
import { AddPopoutSource, addPopoutV2 } from 'owa-popout-v2';
import ItemId from 'owa-service/lib/contract/ItemId';
import EventScope from 'owa-service/lib/contract/EventScope';

export const CALENDAR_POPOUT_OPTIONS = {
    width: 1095,
    height: 640,
};

// Override Start/End properties with Date type.
// They serialize as the ISO string and are parsed
// by owa-calendar deepLinkComposeRouteHandler.
export type SerializableCalendarEvent = Partial<
    Pick<
        CalendarEvent,
        'RequiredAttendees' | 'OptionalAttendees' | 'Locations' | 'Resources' | 'Subject' | 'Body'
    > & { Start: Date; End: Date }
>;

/**
 * Open calendar compose in popout
 * @param itemId of the calendar event
 * @param partialEvent which might contain properties to override the original event
 */
export function popoutCalendarComposeWithItemId(
    itemId: ItemId,
    partialEvent: Partial<CalendarEvent> | null,
    entrySource: string,
    source?: AddPopoutSource
) {
    if (!itemId) {
        return;
    }
    const mailboxInfo = getUserMailboxInfo();
    const calendarEvent: Partial<CalendarEvent> = {
        ItemId: {
            mailboxInfo: mailboxInfo,
            ...itemId,
        },
        ...partialEvent,
    };

    popoutCalendarCompose(
        calendarEvent,
        entrySource,
        !!partialEvent /* eventHasUpdates */,
        source || AddPopoutSource.None
    );
}

export default function popoutCalendarCompose(
    calendarEvent: Partial<CalendarEvent> | SerializableCalendarEvent,
    entrySource: string,
    eventHasUpdates: boolean,
    source?: AddPopoutSource,
    shouldDuplicate?: boolean,
    eventScope?: EventScope
) {
    addPopoutV2(
        'calendar',
        'compose',
        {
            event: calendarEvent,
            composeEntrySource: entrySource,
            shouldDuplicate: shouldDuplicate,
            eventScope: eventScope,
            eventHasUpdates: eventHasUpdates,
        },
        CALENDAR_POPOUT_OPTIONS
    );
}
